import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useScopeOfWork = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'scopeOfWork',
    gqlEntityKey: 'scope_of_work',
    queryName: 'GET_SCOPE_OF_WORK_QUERY',
    createMutation: 'CREATE_SCOPE_OF_WORK_MUTATION',
    updateMutation: 'UPDATE_SCOPE_OF_WORK_MUTATION',
    deleteMutation: 'DELETE_SCOPE_OF_WORK_MUTATION',
    updateVariableName: 'set',
    transformData: (scopeOfWork) => ({
      ...scopeOfWork,
      company_name: scopeOfWork.company?.name || `Company ${scopeOfWork.company_id}`,
      name: scopeOfWork.name,
      description: scopeOfWork.description,
      status: scopeOfWork.status ? 'active' : 'inactive',
      companyId: scopeOfWork.company_id,
    }),
    transformFormData: (formData) => ({
      name: formData.name,
      description: formData.description || null,
      status: formData.status === 'active',
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useScopeOfWork }; 